import React from "react";

export default function TextInput({ id, type = "text", placeholder, required = false, className, containerClassName, ...props }) {
  return (
    <div className={containerClassName}>
      <label htmlFor={id} className="sr-only">
        {placeholder}
      </label>
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        required={required}
        // Merge default styles with custom className
        className={`${className}`}
        {...props}
      />
    </div>
  );
}
